import React, { FC } from "react";
import { ConnectedProps, connect } from "react-redux";

import { IRapComponentProperties } from "../../platform/Layout";
import { IUhfViewState } from "../../pages/Contracts";

interface IAdminViewProvidedProps extends IRapComponentProperties {

}

interface IAdminViewOwnProps {

}

export type IAdminViewProps = ConnectedProps<typeof connector> & IAdminViewProvidedProps;

const AdminViewInitializer: FC<IAdminViewProps> = (props) => {

    return (<>test</>);
}

function mapStateToProps(state: IUhfViewState, providedProps: IAdminViewProvidedProps): Partial<IAdminViewOwnProps> {
    return {
        ...providedProps,
    };
}

const ActionsToDispatch = {

};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const AdminView = connector(AdminViewInitializer);